import api from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/ofertaDemanda");
  return response.data;
};

export const getOfertas = async (tipoBien, id) => {
  const params = {};
  params.tipo = "Oferta";
  params.tipoBien = tipoBien ?? null;
  params.id = id ?? null;
  const response = await api.get("/ofertaDemanda", { params: params });
  return response.data;
};

export const getDemandas = async (tipoBien, id) => {
  const params = {};
  params.tipo = "Demanda";
  params.tipoBien = tipoBien ?? null;
  params.id = id ?? null;

  const response = await api.get("/ofertaDemanda", { params: params });
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/ofertaDemanda/${id}`);
  return response.data;
};

export const create = async (data) => {
  const response = await api.post("/ofertaDemanda", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/ofertaDemanda/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/ofertaDemanda/${id}`);
};
